export async function adicionarDispositivo({ ip, name, description}) {
  const url = `${process.env.REACT_APP_MICROSERVICO_IP}/cmd/devices`;
  const data = { ip, name, description};

  console.log("Dados enviados:", data);

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.text();
    throw new Error(`Erro na resposta: ${response.status} - ${errorData}`);
  }
  return response.json();
}